import React from 'react';
import { useCart } from '../context/CartContext';

const Cart = () => {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();

    const calculateTax = (subtotal) => {
      return subtotal * 0.13;
    };

    const calculateTotal = () => {
      const subtotal = getCartTotal();
      const tax = calculateTax(subtotal);
      return subtotal + tax;
    };
  if (cart.length === 0) {
    return (
      <div className="container-xxl py-5" style={{paddingTop: '120px'}}>
        <div className="container">
          <div className="text-center">
            <h1 className="display-5 mb-4">Your Cart is Empty</h1>
            <p>Add some delicious items to your cart!</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-xxl py-5" style={{paddingTop: '120px'}}>
      <div className="container">
        <h1 className="display-5 mb-4">Shopping Cart</h1>
        <div className="row">
          <div className="col-lg-8">
            {cart.map((item, index) => (
              <div key={index} className="card mb-3">
                <div className="row g-0">
                  <div className="col-md-4">
                    <img src={item.image} className="img-fluid rounded-start h-100" alt={item.name} style={{objectFit: 'cover'}} />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h5 className="card-title">{item.name}</h5>
                      {item.selectedSize && (
                        <p className="card-text text-muted">
                          Size: {item.selectedSize.name} ({item.selectedSize.volume})
                        </p>
                      )}
                      <p className="card-text">
                        <span className="cart-price-green">{item.selectedSize ? item.selectedSize.price : item.price}</span>
                      </p>
                      <div className="d-flex align-items-center">
                        <button 
                          className="btn btn-outline-secondary btn-sm me-2"
                          onClick={() => updateQuantity(item.name, Math.max(1, item.quantity - 1), item.selectedSize)}
                        >
                          -
                        </button>
                        <span className="mx-2">{item.quantity}</span>
                        <button 
                          className="btn btn-outline-secondary btn-sm ms-2"
                          onClick={() => updateQuantity(item.name, item.quantity + 1, item.selectedSize)}
                        >
                          +
                        </button>
                        <button 
                          className="btn btn-danger btn-sm ms-3"
                          onClick={() => removeFromCart({ name: item.name, selectedSize: item.selectedSize })}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-lg-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Order Summary</h5>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>Total Items:</span>
                  <span>{cart.reduce((total, item) => total + item.quantity, 0)}</span>
                </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Subtotal:</span>
                    <span>${getCartTotal().toFixed(2)} CAD</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Tax (13%):</span>
                    <span>${calculateTax(getCartTotal()).toFixed(2)} CAD</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <strong>Total with Tax:</strong>
                    <strong>${calculateTotal().toFixed(2)} CAD</strong>
                </div>
                <hr />
                <button className="btn btn-primary w-100">Proceed to Checkout</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;